'use strict';

angular.module('docketbook').
  controller('selectTemplateController', function(docketService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

    // Initialise variables to be used
    $scope.templateSearch = "";
    $scope.templateSearchLoading = false;
    $scope.templateSearchList = [];
    $scope.templateSearchListFull = [];
    $scope.templatsSearchCallback = null;
    $scope.listCount = 0;
    $scope.desktopSelected = [];

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.templateSelectFromParent = function(currentTemplate, cb) {
      if ( $stateParams.device == 'desktop' ) {
        $("#selectTemplateModal").fadeIn(100);
      }
      $scope.templateSearch = "";
      $scope.templateSelected = currentTemplate;
      $scope.templateSearchLoading = false;
      $scope.templateSelectCallback = cb;
      $scope.desktopSelected = [];
      $scope.loadTemplateList();
    }

    $scope.assignTemplateToDocket = function(template) {
      docketService.getTemplate(template, function(templateFull){
        $scope.templateSelectCallback(templateFull);
      }, function(err) {
        $scope.templateSelectCallback(template);
      });
    }

    $scope.closeTemplateSelectList = function() {
      $scope.templateSelectCallback(null);
      if ( $stateParams.device == 'desktop' ) {
        $("#selectTemplateModal").fadeOut(100);
      }
    }

    $scope.desktopSelectTemplateContinue = function() {
      $scope.assignTemplateToDocket($scope.desktopSelected[0]);
      $("#selectTemplateModal").fadeOut(100);
    }

    $scope.loadTemplateList = function() {
      $scope.promise = $q(function(resolve, reject) {
        docketService.getTemplates({"published": "true"}, function(allTemplates) {
          for ( var i = 0; i < allTemplates.length; i++ ) {
            if ( allTemplates[i].id == $scope.templateSelected.id ) {
              allTemplates[i].existing = true;
            }
          }
          $scope.templateSearchList = allTemplates;
          $scope.templateSearchListFull = allTemplates;
          resolve('Done');
        }, function(err) {
          $scope.templateSearchList = [];
          $scope.templateSearchListFull = [];
          reject('Error');
        });
      });
    }

    /********************************/
    /***** Search Functionality *****/
    /********************************/

    $scope.updateTemplateSearch = function(searchValue) {
      if ( searchValue === "" ) {
        $scope.templateSearchList = $scope.templateSearchListFull;
        return;
      }

      // update addressBookList with filtered results
      var filteredList = [];
      for ( var i = 0; i < $scope.templateSearchListFull.length; i++ ) {
        if ( $scope.templateSearchListFull[i].name.indexOf(searchValue) != -1 ) {
          filteredList.push($scope.templateSearchListFull[i]);
        }
      }

      $scope.templateSearchList = filteredList;
    }

});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectTemplateController.js